// extracted by mini-css-extract-plugin
export default {"popup":"OA5OIcnlh1m52Omm1uJh","smallPopup":"UvW0ew1A42EYqwLHFN7b"};